const textConstants = {
    ENTER_EMAIL: "Enter your work email",
    EMAIL_PLACEHOLDER: "e.g. name@company.com",
    SIGNUP: "Sign up",
    LOGIN: "Login",
    GET_STARTED: "Create your ThriveStack account",
    NO_CREDIT_CARD_REQUIRED: "No credit card required",
    FOOTER_TEXT: "By continuing, you agree to the ",
    EMAIL_SENT_TITLE: "First, let’s verify your email",
    EMAIL_SEND_CODE_MANUALLY_CTA: "Enter code manually",
    EMAIL_SEND_BACK_TO_LOGIN_CTA: "Back to login",
    NEED_HELP: "Need help?",
    CONTACT_SUPPORT: "Visit Support or Contact Us"
};
export default textConstants;
